import { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { getTechnicianById } from 'api/technicians';

import InvitationsCard from 'components/cards/invitations';
import Loading from 'components/loading/loading';

const TechnicianItem = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { id } = useParams();
  const history = useHistory();

  const getTechnician = useCallback(async () => {
    setLoading(true);
    const data_ = await getTechnicianById(id);
    setData(data_);
    setLoading(false);
  }, [id]);

  useEffect(() => {
    getTechnician();
  }, [getTechnician]);

  if (loading || !data) return <Loading />;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <section className="view-container">
          <div className="flex items-center mb10 bt b--lightgrey-d1 pt8">
            <figure className="th-member-gravatar w20 h20 mr4 th-member-detail-avatar">
              <div className="th-member-initials flex items-center justify-center br-100 w20 h20 mr4 th-member-detail-avatar">
                <img
                  className="f-subheadline fw4 lh-zero tracked-1"
                  src={data.avatarUrl || '/images/ghost.svg'}
                  alt=""
                />
              </div>
            </figure>
            <div>
              <h3 className="f2 fw6 ma0 pa0">
                {data.firstName} {data.lastName}
              </h3>
              <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                {data.email}
              </p>
            </div>
            <section className="view-actions" style={{ marginLeft: 'auto' }}>
              <button
                className="btn-green"
                data-cy="edit"
                onClick={() => history.push(`/technicians/${data.id}/edit`)}
              >
                <span>Edit</span>
              </button>
            </section>
          </div>

          <div className="flex flex-column items-center mb10 pt8">
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Phone number</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {data.phone}
                </p>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Country</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {data.country}
                </p>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">City</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {data.city}
                </p>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Address</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {data.address}
                </p>
              </div>
            </div>
            <div className="w-100 flex flex-column items-start justify-between">
              <div className="w-100">
                <span className="apps-grid-title">Additional notes</span>
                <p className="f7 pa0 ma0 midgrey-d1 nudge-bottom--2">
                  {data.notes}
                </p>
              </div>
            </div>
            <InvitationsCard data={data.invitations} />
          </div>
        </section>
      </section>
    </main>
  );
};

export default TechnicianItem;
